'use client';

var _excluded = ["spacing", "className", "children", "iconColor", "iconSize", "icon", "isChecked", "isDisabled", "onChange", "inputProps"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useInitialAnimationState } from "./chunk-2TOCDA5N.mjs";
import { useCheckboxGroupContext } from "./chunk-LYGBQ47X.mjs";
import { CheckboxIcon } from "./chunk-ULEC7HZU.mjs";
import { useCheckbox } from "./chunk-7D6N5TE5.mjs"; // src/checkbox.tsx

import { callAll, cx } from "@chakra-ui/shared-utils";
import { chakra, forwardRef, keyframes, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { cloneElement, useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var controlStyles = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
};
var rootStyles = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
};
var checkAnim = keyframes({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
});
var indeterminateOpacityAnim = keyframes({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var indeterminateScaleAnim = keyframes({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
});
var Checkbox = forwardRef(function Checkbox2(props, ref) {
  var group = useCheckboxGroupContext();

  var mergedProps = _objectSpread(_objectSpread({}, group), props);

  var styles = useMultiStyleConfig("Checkbox", mergedProps);
  var ownProps = omitThemingProps(props);

  var _ownProps$spacing = ownProps.spacing,
      spacing = _ownProps$spacing === void 0 ? "0.5rem" : _ownProps$spacing,
      className = ownProps.className,
      children = ownProps.children,
      iconColor = ownProps.iconColor,
      iconSize = ownProps.iconSize,
      _ownProps$icon = ownProps.icon,
      icon = _ownProps$icon === void 0 ? /* @__PURE__ */jsx(CheckboxIcon, {}) : _ownProps$icon,
      isCheckedProp = ownProps.isChecked,
      _ownProps$isDisabled = ownProps.isDisabled,
      isDisabled = _ownProps$isDisabled === void 0 ? group == null ? void 0 : group.isDisabled : _ownProps$isDisabled,
      onChangeProp = ownProps.onChange,
      inputProps = ownProps.inputProps,
      rest = _objectWithoutProperties(ownProps, _excluded);

  var isChecked = isCheckedProp;

  if ((group == null ? void 0 : group.value) && ownProps.value) {
    isChecked = group.value.includes(ownProps.value);
  }

  var onChange = onChangeProp;

  if ((group == null ? void 0 : group.onChange) && ownProps.value) {
    onChange = callAll(group.onChange, onChangeProp);
  }

  var _useCheckbox = useCheckbox(_objectSpread(_objectSpread({}, rest), {}, {
    isDisabled: isDisabled,
    isChecked: isChecked,
    onChange: onChange
  })),
      state = _useCheckbox.state,
      getInputProps = _useCheckbox.getInputProps,
      getCheckboxProps = _useCheckbox.getCheckboxProps,
      getLabelProps = _useCheckbox.getLabelProps,
      getRootProps = _useCheckbox.getRootProps;

  var shouldAnimate = useInitialAnimationState(state.isChecked);
  var iconStyles = useMemo(function () {
    return _objectSpread({
      animation: !shouldAnimate ? void 0 : state.isIndeterminate ? "".concat(indeterminateOpacityAnim, " 20ms linear, ").concat(indeterminateScaleAnim, " 200ms linear") : "".concat(checkAnim, " 200ms linear"),
      fontSize: iconSize,
      color: iconColor
    }, styles.icon);
  }, [iconColor, iconSize, shouldAnimate, state.isIndeterminate, styles.icon]);
  var clonedIcon = cloneElement(icon, {
    __css: iconStyles,
    isIndeterminate: state.isIndeterminate,
    isChecked: state.isChecked
  });
  return /* @__PURE__ */jsxs(chakra.label, _objectSpread(_objectSpread({
    __css: _objectSpread(_objectSpread({}, rootStyles), styles.container),
    className: cx("chakra-checkbox", className)
  }, getRootProps()), {}, {
    children: [/* @__PURE__ */jsx("input", _objectSpread({
      className: "chakra-checkbox__input"
    }, getInputProps(inputProps, ref))), /* @__PURE__ */jsx(chakra.span, _objectSpread(_objectSpread({
      __css: _objectSpread(_objectSpread({}, controlStyles), styles.control),
      className: "chakra-checkbox__control"
    }, getCheckboxProps()), {}, {
      children: clonedIcon
    })), children && /* @__PURE__ */jsx(chakra.span, _objectSpread(_objectSpread({
      className: "chakra-checkbox__label"
    }, getLabelProps()), {}, {
      __css: _objectSpread({
        marginStart: spacing
      }, styles.label),
      children: children
    }))]
  }));
});
Checkbox.displayName = "Checkbox";
export { Checkbox };